import Modal from "@/components/Modals/Modal";
import { Link } from "react-router-dom";
import LogoAppWhoop from "@/assets/appwhoop_ticket_logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AuthPromptModal({ isOpen, onClose, returnTo }) {
  const isValidReturn =
    returnTo?.startsWith("/evento/") || returnTo?.startsWith("/experiencias/");
  const routeState = isValidReturn ? { from: returnTo } : undefined;

  const handleGoogleSignIn = () => {
    if (returnTo) sessionStorage.setItem("auth_return_to", returnTo);
    const redirectUri = `${window.location.origin}/auth/callback`;
    const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
    const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
    window.location.href = `${cognitoDomain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=openid+email+profile&redirect_uri=${encodeURIComponent(redirectUri)}&identity_provider=Google&prompt=select_account`;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} large="max-w-sm">
      <div className="bg-aw-bluedark rounded-2xl p-8 flex flex-col items-center gap-6 text-white text-center shadow-xl">
        <img src={LogoAppWhoop} alt="AppWhoop" className="w-28 h-auto" />
        <div>
          <h3 className="text-xl font-bold mb-1">¿Tienes una cuenta?</h3>
          <p className="text-sm text-white/60">
            Regístrate o inicia sesión para continuar
          </p>
        </div>
        <div className="flex flex-col gap-3 w-full">
          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="w-full flex items-center justify-center gap-3 bg-white text-gray-800 font-semibold py-3 rounded-xl hover:bg-gray-50 hover:scale-95 transition-all duration-200 text-sm shadow-md"
          >
            <FontAwesomeIcon icon="fa-brands fa-google" className="text-[#DB4437] text-base" />
            Continuar con Google
          </button>

          <div className="flex items-center gap-3 my-1">
            <div className="flex-1 h-px bg-white/20" />
            <span className="text-xs text-white/40">O también puedes</span>
            <div className="flex-1 h-px bg-white/20" />
          </div>

          <Link
            to="/login"
            state={routeState}
            onClick={onClose}
            className="w-full bg-white/10 text-white font-semibold py-2.5 rounded-xl hover:bg-white/20 hover:scale-95 transition-all duration-200 text-sm"
          >
            Iniciar Sesión
          </Link>
          <Link
            to="/signup"
            state={routeState}
            onClick={onClose}
            className="w-full bg-aw-green text-black font-semibold py-2.5 rounded-xl hover:scale-95 transition-transform duration-200 text-sm"
          >
            Registrarme Gratis
          </Link>
        </div>
      </div>
    </Modal>
  );
}
